module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_grand_title_favorite-4636c969c883c225bc800c4f1b70d207.svg";